import React from 'react'
import Style from './RequestPerview.module.css'
import { itemListData } from '../ItemCategory/itemListData'
const RequestPerview = ({data}) => {
    const categorySelect=itemListData.find(item=>item.key===parseInt(data.categoryItemKey))
    console.log(data)
  return (
    <div className={Style.component__holder}>
    <section className={Style.detail__perview}>
        <h3>اطلاعات مبدا و فرستنده</h3>
        <div>
            <strong>آدرس: </strong>
            <span>{data?.origin.address}</span>
        </div>
        <div>
            <strong>نام و نام خانوادگی: </strong>
            <span>{data?.senderInfo.senderName}</span>
        </div>
        <div>
            <strong>شماره تماس: </strong>
            <span>{data?.senderInfo.senderPhone}</span>
        </div>
        {data?.senderInfo.senderDescription&&        <div>
            <strong>توضیحات: </strong>
            <span>{data?.senderInfo.senderDescription}</span>
        </div>}
      </section>
    <section className={Style.detail__perview}>
        <h3>اطلاعات مقصد و گیرنده</h3>
        <div>
            <strong>آدرس: </strong>
            <span>{data?.destination.address}</span>
        </div>
        <div>
            <strong>نام و نام خانوادگی: </strong>
            <span>{data?.resiverInfo.resiverName}</span>
        </div>
        <div>
            <strong>شماره تماس: </strong>
            <span>{data?.resiverInfo.resiverPhone}</span>
        </div>
        {data?.resiverInfo.resiverDescription&&        <div>
            <strong>توضیحات: </strong>
            <span>{data?.resiverInfo.resiverDescription}</span>
        </div>}
      </section>
      {
        data.secondDestination&&
        <section className={Style.detail__perview}>
        <h3>اطلاعات مقصد دوم و گیرنده دوم</h3>
        <div>
            <strong>آدرس: </strong>
            <span>{data?.destination2.address}</span>
        </div>
        <div>
            <strong>نام و نام خانوادگی: </strong>
            <span>{data?.resiver2Info.resiver2Name}</span>
        </div>
        <div>
            <strong>شماره تماس: </strong>
            <span>{data?.resiver2Info.resiver2Phone}</span>
        </div>
        {data?.resiver2Info.resiver2Description&&        <div>
            <strong>توضیحات: </strong>
            <span>{data?.resiver2Info.resiver2Description}</span>
        </div>}
      </section>
      }
          <section className={Style.detail__perview}>
        <h3>اطلاعات مرسوله </h3>
        <div>
            <strong>دسته بندی: </strong>
            <span>{categorySelect?.lable}</span>
        </div>
        {data?.typedCategory&&<div>
            <strong> دسته بندی وارد شده: </strong>
            <span>{data?.typedCategory}</span>
        </div>}
        <div>
            <strong>وزن و اندازه: </strong>
            <span>{data?.productDescription}</span>
        </div>
      </section>
    </div>
  )
}

export default RequestPerview